import { ControlValueAccessor } from "@angular/forms";
import { DatePipe } from "@angular/common";


export class ValueAccessorBase<E> implements ControlValueAccessor {

    private _value: E;
   // protected initialValue : any;
    private _changed = new Array<(value: E) => void>();
    private _touched = new Array<() => void>();


    protected pipe    : DatePipe = new DatePipe('en-US');


    public formatDate(date : Date){
        return this.pipe.transform(date, 'dd-MM-yyyy   hh:mm');
    }
  

    public get value(): E {
        return this._value;
    }

    public set value(value: E) {
        if (this._value !== value) {
            this._value = value;
            this._changed.forEach(f => f(value));
        }
    }

    public touch() {
        this._touched.forEach(f => f());
    }

    public writeValue(value: E) {
        if (!this._value || value !== this._value){
            this._value = value;
        }
    }

    public registerOnChange(fn: (value: E) => void) {
        this._changed.push(fn);
    }

    public registerOnTouched(fn: () => void) {
        this._touched.push(fn);
    }

}

